import pkdApi from 'store/api/pkd';

const countryApi = pkdApi.injectEndpoints({
  endpoints : (build) => ({
    getStates : build.query({
      query : () => ({
        url    : '../v1/countries',
        method : 'GET',
      }),
      providesTags : ['Country'],
    }),
  }),
  overrideExisting : false,
});

export const {
  useGetStatesQuery
} = countryApi;
